import { render, staticRenderFns } from "./CausesTab.vue?vue&type=template&id=00f71c08&scoped=true"
import script from "./CausesTab.vue?vue&type=script&lang=js"
export * from "./CausesTab.vue?vue&type=script&lang=js"
import style0 from "./CausesTab.vue?vue&type=style&index=0&id=00f71c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f71c08",
  null
  
)

export default component.exports